module.exports = __webpack_public_path__ + "img/kraken.fc2d58cd.png";